import { queryOptions } from "@tanstack/react-query";
import { getPriceBoard } from "@/lib/prices.functions";

/** One freshness policy for every server-rendered and interactive price surface. */
export const priceBoardQueryOptions = () =>
  queryOptions({
    queryKey: ["price-board"],
    queryFn: () => getPriceBoard(),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: "always" as const,
    refetchInterval: 15 * 60 * 1000,
  });